import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { zakelijkKozijnCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";

export const ConfigurationPricingFooter = () => {
  const { calculateExtrasPrice, getConfiguredOptionPrices, selectedDoor } =
    useConfigurationOptionsContext();
  const configuredOptionPrices = getConfiguredOptionPrices();

  // Get the price of each option
  const colorPrice = "€" + configuredOptionPrices.color.toFixed(2);
  const glassPrice = "€" + configuredOptionPrices.glass.toFixed(2);
  const handlePrice = "€" + configuredOptionPrices.handle.toFixed(2);

  // Calculate the total price of extras
  const extraTotal = calculateExtrasPrice();
  const extrasPrice = "€" + extraTotal.toFixed(2);

  // Check if the selected door is a kozijn product
  const isKozijnProduct = zakelijkKozijnCodes.includes(
    selectedDoor?.code ?? "",
  );

  // Handle text based on product type
  const handleText = isKozijnProduct ? "Type slot" : "Deurbeslag";

  return (
    <div className="gg-flex">
      <div className="gg-grid gg-h-min gg-grid-cols-2 gg-items-center gg-gap-x-5 gg-gap-y-2.5 gg-text-xs sm:gg-h-full sm:gg-gap-y-[1px] sm:gg-text-sm">
        {/* Kleur */}
        <h5 className="gg-font-semibold gg-text-dark-blue">Kleur</h5>
        <p className="gg-text-xs gg-text-purple-300">{colorPrice}</p>

        {/* Glas */}
        {!isKozijnProduct && (
          <>
            <h5 className="gg-font-semibold gg-text-dark-blue">Glas</h5>
            <p className="gg-text-xs gg-text-purple-300">{glassPrice}</p>
          </>
        )}

        {/* Handle */}
        <h5 className="gg-font-semibold gg-text-dark-blue">{handleText}</h5>
        <p className="gg-text-xs gg-text-purple-300">{handlePrice}</p>

        {/* Extras */}
        <h5 className="gg-font-semibold gg-text-dark-blue">Extras</h5>
        <p className="gg-text-xs gg-text-purple-300">{extrasPrice}</p>
      </div>
    </div>
  );
};
